import { useCallback } from 'react';

import { WidgetConfigSitePanel } from '@/components/widgetConfigSiteTabbedShell/widgetConfigSiteTabbedShell/widgetConfigSiteTabbedShellContent/widgetSiteTabbedConfig/WidgetConfigSitePanel.tsx';
import { InventorySiteSection } from '@/types.ts';

import { useWidgetSiteTabbedShellCtx } from '../widgetSiteTabbedShellProvider/WidgetSiteTabbedShellContext.ts';
import { SiteTabbedInventoryLayout } from './widgetSiteTabbedConfig/SiteTabbedInventoryLayout.tsx';
import type { WidgetSiteTabbedConfigProps } from './widgetSiteTabbedConfig/siteTabbedInventoryLayout/siteTabbedInventoryLayout.types.ts';

export const WidgetSiteTabbedConfig = ({
  onSave,
  renderSitePanel,
  ...sharedProps
}: WidgetSiteTabbedConfigProps) => {
  const { defaultSiteKey, activeSiteKey, setActiveSiteKey, registerSave } =
    useWidgetSiteTabbedShellCtx();

  const renderWrappedPanel = useCallback(
    (section: InventorySiteSection) => (
      <WidgetConfigSitePanel section={section} onSave={onSave} registerSaveForSite={registerSave}>
        {renderSitePanel()}
      </WidgetConfigSitePanel>
    ),
    [onSave, registerSave, renderSitePanel]
  );

  return (
    <SiteTabbedInventoryLayout
      {...sharedProps}
      renderPanel={renderWrappedPanel}
      selectedSiteKey={activeSiteKey}
      onSiteKeyChange={setActiveSiteKey}
      defaultSiteKey={defaultSiteKey}
    />
  );
};
